/** User-visible message from Firebase / network errors. */
export function formatFirebaseError(err) {
  if (!err) return "Unknown error";
  const code = err.code ? `[${err.code}] ` : "";
  const msg = err.message || String(err);
  if (msg.includes("permission") || err.code === "permission-denied") {
    return `${code}Permission denied. Ask admin to allow writes to sales_transactions, sales_import_months (and lineChunks), weekly_imports, upload_logs, and upload_errors in Firestore rules.`;
  }
  if (err.code === "invalid-argument" && msg.toLowerCase().includes("document")) {
    return `${code}Invalid document ID in data. Check Bill No and Product ID for special characters.`;
  }
  return `${code}${msg}`;
}
